
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelatedEntities"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleEntityRelations"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasVideo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasAudio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasStream"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasGallery"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"media"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoData"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoDuration"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":182}};
    doc.loc.source = {"body":"fragment RelatedEntities on ArticleEntityRelations {\n  hasVideo\n  hasAudio\n  hasStream\n  hasGallery\n  media {\n    items {\n      videoData {\n        videoDuration\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
